import { NativeSelect } from '@mantine/core'
import NativeSelectClasses from './styles.module.css'
import '../../styles/variables.css'

export default NativeSelect.extend({
    defaultProps: { radius: 'lg', size: 'lg' },
    classNames: NativeSelectClasses,
})
